<template>
  <div>
    <v-dialog v-model="darAlta" hide-overlay persistent max-width="800">
      <v-card>
        <v-system-bar color="headeryfooter darken-2" dark>
          <v-spacer></v-spacer>
          <v-icon @click="darAlta = false">mdi-close</v-icon>
        </v-system-bar>
        <v-container>
          <v-row>
            <v-col md="3">
              <v-select
                dense
                v-model.number="motivo.id_estado"
                :items="estados"
                item-text="descripcion_estado"
                item-value="id_estado"
                :return-object="false"
                hide-selected
                hide-details
              >
              </v-select>
            </v-col>
            <v-col md="7">
              <v-text-field
                dense
                hide-details
                label="Motivo"
                v-model="motivo.descripcion_motivo"
                clearable
              >
              </v-text-field>
            </v-col>
            <v-col md="2">
              <v-btn
                @click="guardo(motivo)"
                :disabled="!motivo.descripcion_motivo || !motivo.id_estado"
                >Guardar</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <v-row justify="center">
      <v-col md="8">
        <v-card color="fondoformulario">
          <v-card-title>
            <v-col md="3">
              <v-select
                label="filtrar"
                dense
                v-model.number="busqueda_estado"
                :items="estados_todos"
                item-text="descripcion_estado"
                item-value="id_estado"
                :return-object="false"
                hide-selected
                hide-details
              >
              </v-select>
            </v-col>
            <v-col md="5">
              <v-text-field
                v-model="busqueda"
                prepend-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
                clearable
                clear-icon="mdi-close-circle-outline"
              ></v-text-field>
            </v-col>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn @click="setNuevo" small fab dark v-on="on" color="teal">
                  <v-icon dark>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>Nuevo Motivo</span>
            </v-tooltip>
          </v-card-title>
          <v-card-text>
            <h3 class="text-center">Motivo</h3>
            <v-divider class="mb-2"></v-divider>
            <div style="max-height: 50vh" class="overflow-y-auto">
              <v-row v-for="entidad in ListaFiltrada" :key="entidad.id_motivo">
                <v-col md="3">
                  <v-select
                    dense
                    v-model.number="entidad.id_estado"
                    :items="estados"
                    item-text="descripcion_estado"
                    item-value="id_estado"
                    :return-object="false"
                    hide-selected
                    hide-details
                    @change="guardo(entidad)"
                  >
                  </v-select>
                </v-col>
                <v-col md="8">
                  <v-text-field
                    dense
                    hide-details
                    label="Motivo"
                    v-model="entidad.descripcion_motivo"
                    clearable
                    @change="guardo(entidad)"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import API from "@/lib/API";
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      darAlta: false,
      busqueda: "",
      busqueda_estado: 0,
      motivo: {
        id_motivo: 0,
        id_estado: 0,
        descripcion_motivo: "",
      },
      lista_estados: [
        { id_estado: 1, descripcion_estado: "Pendiente" },
        { id_estado: 2, descripcion_estado: "Autorizado" },
        { id_estado: 3, descripcion_estado: "En Gestion" },
        { id_estado: 4, descripcion_estado: "Rechazado" },
      ],
    };
  },
  computed: {
    ...mapState("motivos", ["Lista"]),
    estados() {
      return this.lista_estados.filter((x) => x.id_estado > 2);
    },
    estados_todos(){
      let est = this.lista_estados.filter((x) => x.id_estado > 2);
      est.unshift({ id_estado: 0, descripcion_estado: "-- Todos --" },)
      return est;
    },
    ListaFiltrada() {
      let busqueda = this.busqueda || "";
      return this.Lista.filter(
        (x) =>
          x.id_motivo > 0 &&
          x.id_estado > 2 &&
          x.descripcion_motivo.toUpperCase().indexOf(busqueda.toUpperCase()) >
            -1
          && 
          (x.id_estado == this.busqueda_estado || this.busqueda_estado == 0)
      );
    },
  },
  methods: {
    ...mapActions("motivos", ["guardarEntidad"]),
    setNuevo() {
      this.motivo.id_motivo = 0;
      this.motivo.id_estado = 0;
      this.motivo.descripcion_motivo = "";
      this.darAlta = true;
    },
    guardo(motivo) {
      this.guardarEntidad(motivo);
      this.darAlta = false;
    },
  },
};
</script>

<style></style>
